import type { ReactNode } from "react";
import "@knowtex-ai/components/style.css";
import { ToastProvider } from "@knowtex-ai/components";
import Sidebar from "../Sidebar";

interface McPageShellProps {
  setAuth: (isAuthenticated: boolean) => void;
  setUserOrg: (org: string | null) => void;
  children: ReactNode;
}

export default function McPageShell({ setAuth, setUserOrg, children }: McPageShellProps) {
  return (
    <ToastProvider>
      <div className="flex min-h-screen bg-[#fafafa]">
        <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
        <div className="flex-1 min-w-0" style={{ marginLeft: "var(--sidebar-width, 250px)" }}>
          <div className="max-w-[1280px] mx-auto px-6 py-8 md:px-10">{children}</div>
        </div>
      </div>
    </ToastProvider>
  );
}
